<template>
  <div class="block">
    <el-select v-model="selected"
               placeholder="Ej: Región Metropolitana"
               value="value"
               @change="selectRegion"
               clearable
               @clear="clean"
               filterable>
      <el-option v-for="region in data.regions"
                 :key="region.id"
                 :label="region.name"
                 :value="region.name"></el-option>
    </el-select>
  </div>
</template>

<script>
import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  name: 'BaseSelectRegion',
  data() {
    return {
      data: {
        regions: [],
      },
      selected: null,
    };
  },
  methods: {
    getAllRegions() {
      apiRequest({
        module: 'crud',
        service: 'get_regions',
        params: {
          limit: 1000,
        },
      }).then((response) => {
        this.data.regions = response.data;
        sessionStorage.regions = JSON.stringify(
          response.data.sort((a, b) => (b.name > a.name ? -1 : 1)),
        );
      }).catch(() => {
        this.error = 'Get Regions Failed!';
        this.$message.error('Error al obtener las regiones, por favor intente nuevamente');
      });
    },
    selectRegion() {
      for (let i = 0; i < this.data.regions.length; i += 1) {
        if (this.selected === this.data.regions[i].name) {
          this.$emit('sendRegion', this.data.regions[i].id);
        }
      }
    },
    getRegionsFromLS() {
      this.data.regions = JSON.parse(sessionStorage.regions);
    },
    clean() {
      this.$emit('sendRegion', -1);
    },
  },
  created() {
    if (sessionStorage.regions) {
      this.getRegionsFromLS();
    } else {
      this.getAllRegions();
    }
  },
};
</script>

<style scoped>

</style>
